import { useEffect } from 'react';
import { useIndexedDB } from 'react-indexed-db-hook';
import { useSelector } from 'react-redux';

export const useDownloadAvatar = () => {
  const { add, getAll } = useIndexedDB('image');
  const { avatar } = useSelector((state) => state.authSlice);
  const refetchDownloadingAvatar = async () => {
    const allImages = await getAll();
    const imageRecord = allImages.find((img) => img.url === avatar);
    return imageRecord;
  };
  useEffect(() => {
    const init = async () => {
      const imageRecord = await refetchDownloadingAvatar();
      if (!imageRecord) {
        try {
          const response = await fetch(avatar, {
            cache: 'no-cache',
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          });
          localStorage.setItem('avatarURL', avatar);

          const blob = await response.blob();
          await add({ file: blob, url: avatar });
        } catch {
          // console.log('error while fetching image');
        }
      } else if (localStorage.getItem('avatarURL') !== avatar)
        localStorage.setItem('avatarURL', avatar);
    };
    if (avatar) init();
  }, [avatar]);
  return refetchDownloadingAvatar;
};
